import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import buildContextMenu from '../Common/BuildContextMenu';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import DetailView from '../Common/DetailView';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import EventDialogCreate from '../Event/EventDialogCreate';
import Timeline from 'react-calendar-timeline/lib';
import 'react-calendar-timeline/lib/Timeline.css';
import moment from 'moment';
import CalendarIcon from 'material-ui/svg-icons/action/date-range';
import ScheduleIcon from 'material-ui/svg-icons/communication/clear-all';
import InfoIcon from 'material-ui/svg-icons/action/info';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import VenueStore from '../../stores/VenueStore';
import VenueLocationStore from '../../stores/VenueLocationStore';
import VenueEventStore from '../../stores/VenueEventStore';
import VenueActions from '../../actions/VenueActionCreator';
import ROLES from '../../constants/Roles';
import EventActions from '../../actions/EventActionCreator';
import { withId } from '../Common/Decorators';
import { statusColours } from '../../constants/ColourConstants';
import EventDialog from '../Event/EventDialog';

moment.updateLocale('en', { week: { dow: 1 }});

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

const getScheduleItem = (event => ({
    id: event.id,
    group: event.locationId,
    title: event.name,
    start_time: moment(event.timeStart).valueOf(),
    end_time: moment(event.timeEnd).valueOf(),
}));

const getGroupItem = ({id, name}) => ({id, title: name});

const getMenuItems = ({id}) => [
    {
        link: `/dashboard/venue/${id}`,
        icon: <InfoIcon />,
        label: 'Preview',
    },
    { type: 'divider' },
    {
        link: `/dashboard/venue/${id}/settings`,
        icon: <SettingsIcon />,
        label: 'Settings',
        condition: {
            roles: [ROLES.ADMIN]
        }
    }
];

const groupRenderer = ({group}) => (
    <div className="schedule-group location">
        <Link to={`/dashboard/location/${group.id}`}><span className="title">{group.title}</span></Link>
        <p className="tip">{group.tip}</p>
    </div>
);

let timeout;

class VenueSchedule extends Component {
    constructor(props) {
        super(props);

        this.state = {
            venue: '',
            events: [],
            locations: [],
            groups: [],
            scheduleItems: [],
            startDate: moment().startOf('week'),
            endDate: moment().endOf('week'),
            selectedEvent: null,

            newEvent: false,
        };
    }

    componentWillMount() {
        this.onEventChange();
        this.onVenueChange();
        this.onVenueLocationsChange();
    }

    componentDidMount() {
        this.onEventChange = this.onEventChange.bind(this);
        this.onVenueChange = this.onVenueChange.bind(this);
        this.onVenueLocationsChange = this.onVenueLocationsChange.bind(this);
        this.selectEvent = this.selectEvent.bind(this);
        this.onCanvasClick = this.onCanvasClick.bind(this);
        this.closeEventDialog = this.closeEventDialog.bind(this);
        this.submitNewEvent = this.submitNewEvent.bind(this);

        this.listeners = [
            VenueEventStore.addListener(this.onEventChange),
            VenueStore.addListener(this.onVenueChange),
            VenueLocationStore.addListener(this.onVenueLocationsChange),
        ];

        const limits = {
            startDate: this.state.startDate.clone().subtract(1, 'week').toISOString(true),
            endDate: this.state.endDate.clone().add(1, 'week').toISOString(true)
        };
        VenueActions.getEvents(this.props.id, limits);
        VenueActions.getById(this.props.id);
        VenueActions.getLocations(this.props.id);
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }

    render() {
        return(
            <DetailView actions={buildContextMenu(getMenuItems(this.props), this.context.auth)}>
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title="Schedule"
                            subtitle={this.state.venue}
                            avatar={<ScheduleIcon style={style.icon} color={statusColours.default} />}
                        />
                        <div className="cent-card-header-buttons">
                            <Link to={`/dashboard/venue/${this.props.id}/events`}><CalendarIcon className='cent-icon' color={statusColours.default}/></Link>
                        </div>
                        <CardText className="cent-card-text">
                            <Timeline
                                headerLabelGroupHeight={40}
                                headerLabelHeight={40}
                                lineHeight={60}
                                groups={this.state.groups}
                                items={this.state.scheduleItems}
                                sidebarContent=""
                                canMove={false}
                                canResize={false}
                                canChangeGroup={false}
                                defaultTimeStart={this.state.startDate}
                                defaultTimeEnd={this.state.endDate}
                                onItemClick={this.selectEvent}
                                onItemSelect={this.selectEvent}
                                onCanvasClick={this.onCanvasClick}
                                stackItems={true}
                                onBoundsChange={this.onBoundsChange}
                                groupRenderer={groupRenderer}
                            />
                        </CardText>
                    </Card>
                </div>
                <EventDialog
                    event={this.state.selectedEvent}
                    onClose={() => this.selectEvent()}
                    editLink={ROLES.ADMIN && this.state.selectedEvent && `/dashboard/event/${this.state.selectedEvent.id}/edit`}
                />

                {this.state.newEvent && (
                    <EventDialogCreate
                        title="Create new event"
                        open={true}
                        {...this.state.newEvent}
                        locations={this.state.locations}
                        onClose={this.closeEventDialog}
                        onSave={this.submitNewEvent}
                    />
                )}
                <ErrorSnackbar/>
            </DetailView>
        );
    }

    onEventChange() {
        const events = VenueEventStore.getByVenue(Number(this.props.id));
        if (events !== undefined) {
            this.setState({events, scheduleItems: events.map(getScheduleItem)});
        }
    }

    onVenueChange() {
        const venue = VenueStore.getById(this.props.id);
        if (venue !== undefined) {
            this.setState({venue: venue.name});
        }
    }

    onVenueLocationsChange() {
        const locations = VenueLocationStore.getByVenue(this.props.id);
        if (!!locations) {
            this.setState({ locations, groups: locations.map(getGroupItem) });
        }
    }

    onBoundsChange(canvasTimeStart, canvasTimeEnd) {
        const limits = {
            startDate: moment(canvasTimeStart).toISOString(false),
            endDate: moment(canvasTimeEnd).toISOString(false)
        };
        timeout && clearTimeout(timeout);
        timeout = setTimeout(() => EventActions.getTrainersEvents(limits), 100);
    }

    selectEvent(eventId) {
        const selectedEvent = !!eventId && this.state.events.find(({id}) => id === eventId);
        this.setState({selectedEvent});
    }

    onCanvasClick(locationId, time) {
        const start = moment(time);
        const newEvent = {
            open: true,
            start,
            locationId,
            end: start.clone().add('1', 'hour'),
            eventDates: start.format('LL'),
        };
        this.setState({newEvent});

    }

    closeEventDialog() {
        this.setState({newEvent: false});
    }

    submitNewEvent(data) {
        data.description = '';
        data.venueId = this.props.id;
        data.periodic = false;

        const limits = {
            startDate: moment(data.timeStart).subtract(1, 'hours').toISOString(false),
            endDate: moment(data.timeEnd).add(1, 'hours').toISOString(false),
        };
        EventActions.save(data)
            .then(() => VenueActions.getEvents(this.props.id, limits));
        this.closeEventDialog();
    }
}

VenueSchedule.contextTypes = {
    auth:       PropTypes.object
};

export default withId(VenueSchedule);
